import { Form } from "@shared/antd/form";
import { Input } from "@shared/antd/input";
import { Card } from "@shared/antd/card";
import { Alert } from "@shared/antd/alert";
import { Spin } from "@shared/antd/spin";
import * as React from "react";
import { inject, observer } from "mobx-react";
import { Redirect, withRouter } from "react-router-dom";
import { IReactionDisposer, observable, toJS } from "mobx";
import { FormattedMessage, injectIntl, IntlShape } from "react-intl";
import { ReadonlyField } from "../../components/ReadonlyField";
import {
  collection,
  getCubaREST,
  injectMainStore,
  instance,
  MultilineText,
  withLocalizedForm,
} from "@cuba-platform/react";

import "../../../app/App.css";

import AbstractBprocEdit from "../Bproc/abstract/AbstractBprocEdit";
import Page from "../../hoc/PageContentHoc";
import Section from "../../hoc/Section";
import Buttonv2, { ButtonType } from "../../components/Button/Button";
import { goBackOrHomePage } from "../../util";
import LoadingPage from "../LoadingPage";
import { restServices } from "../../../cuba/services";
import { PersonProfile } from "../MyTeam/MyTeamCard";
import { DicRequestStatus } from "../../../cuba/entities/base/tsadv$DicRequestStatus";
import Notification from "../../util/Notification/Notification";
import { OrderRegister, OrderRegisterFull, RegisterOrderRequest } from "../../../cuba/entities/kms_OrderRegister";
import DefaultDatePicker from "../../components/Datepicker";
import moment from "moment";
import { OrderChangeRequest } from "../../../cuba/entities/kms_OrderChangeRequest";
import AttachmentsComponent from "../LearningBudget/component/attachments-component";
import { renderFileLink } from "../LearningBudget/Approvment/AttachmentsComponent";
import CardCollapse from "../../common/card-collapse";
import { MOBILE_ROUTES } from "../../mobile-routes";
import { RegisterOrderRequestManagement } from "../RegisterOrderRequest/RegisterOrderRequestManagement";
import OrderRegisterSheet from "../RegisterOrderRequest/register-order-sheet/order-register-sheet";

type EditorProps = {
  entityId: string;
};


type State = {
  isLoading: boolean;
  isLoadingList: boolean;
  isFirstLoading: boolean;
  personGroupId: string;
  isOrderModal: boolean;
  isPersonModal: boolean;
  isSaving: boolean;
  isRedirect: boolean;
  order: OrderRegisterFull | null;
}


const PageWrapper: React.FC<{ intl: IntlShape }> = ({ children, intl }) => {
  return (
    <Page pageName={intl.formatMessage({ id: "orderRegister" })}>
      <Section className="large" size={"large"}>
        {children}
      </Section>
    </Page>
  );
};

@inject("rootStore")
@injectMainStore
@observer
class RegisterOrderComponent extends AbstractBprocEdit<OrderRegisterFull, EditorProps> {

  processDefinitionKey = "registerOrderRequest";

  dataInstance = instance<OrderRegisterFull>(OrderRegister.NAME, {
    view: "orderRegister.browse",
    loadImmediately: false,
  });


  @observable
  updated = false;
  reactionDisposer: IReactionDisposer;

  @observable
  changedMap = new Map<string, boolean>();

  customKeyForTaskService = "registerOrderService";

  @observable
  person: PersonProfile;

  fields = [

    "initiatorPersonGroup",

    "description",

    "files",

    "order",

    "requestDate",

    "requestNumber",

    "status",
  ];

  isUpdateBeforeOutcome = false;

  isNeedUpdateEntitiesBeforeOpenModal = false;

  @observable
  globalErrors: string[] = [];

  statusesDc = collection<DicRequestStatus>("tsadv$DicOrderStatus", {
    view: "_minimal",
  });

  columnsAttachments = [
    {
      title: <FormattedMessage id={"file"} />,
      dataIndex: "attachments",
      render: renderFileLink,
    },
  ];

  validate = (): Promise<boolean> => {
    let isValidatedSuccess = true;
    this.props.form.validateFields(
      this.fields,
      { force: true },
      (err) => {
        isValidatedSuccess = !err;
        if (err) {
          Notification.error({
            message: this.props.intl.formatMessage({
              id: "management.editor.validationError",
            }),
          });
        }
      },
    );

    return new Promise(resolve => resolve(isValidatedSuccess));
  };

  @observable balanceSum = 0;

  @observable
  approverHrRoleCode: string;

  state: State = {
    isLoading: false,
    isLoadingList: false,
    isFirstLoading: true,
    personGroupId: "",
    isOrderModal: false,
    isPersonModal: false,
    isSaving: false,
    isRedirect: false,
    order: null,
  };

  render() {

    // let isNotDraft = this.isNotDraft();

    if (!this.dataInstance) {
      return <LoadingPage />;
    }
    console.log(toJS(this.dataInstance.item));

    if (this.updated) {
      return <Redirect to={this.dataInstance.item && this.dataInstance.item.id} />;
    }

    if (this.state.isRedirect) {
      return <Redirect exact={true} to={`${RegisterOrderRequestManagement.PATH}/${this.props.entityId}`} />;
    }

    const actions =
      [
        <Buttonv2
          key={"close"}
          buttonType={ButtonType.FOLLOW}
          onClick={() => goBackOrHomePage(this.props.history!)}>
          {this.props.intl.formatMessage({ id: "close" })}
        </Buttonv2>,
      ];

    const styleInput = { style: { marginBottom: "12px", width: "100%" } };
    const { state } = this;

    const files = state.order?.files
      ?.filter(file => file?.pdfFile)
      .map(file => ({
        file: { ...file!.pdfFile },
      }));

    const filterdAction = actions.filter(item => item !== null && item);
    return (
      <Spin spinning={state.isLoading} size="large">
        <PageWrapper intl={this.props.intl}>
          <Card
            className="narrow-layout card-actions-container"
            bordered={false}
            actions={filterdAction}>

            <Form layout="vertical">
              <ReadonlyField
                disabled
                entityName={RegisterOrderRequest.NAME}
                propertyName="initiatorPersonGroup"
                form={this.props.form}
                formItemOpts={{ style: { marginBottom: "12px", display: "none" } }}
                getFieldDecoratorOpts={{}}
              />

              {/*1 oo*/}
              <div className="flex flex-col gap-4 lg:flex-row">
                <Form.Item
                  style={styleInput.style}
                  label={this.props.intl.formatMessage({
                    id: "registerOrderRequest.orderType",
                  })}
                >
                  <Input value={state.order?.orderType?._instanceName} disabled={true} />
                </Form.Item>

                <Form.Item
                  style={styleInput.style}
                  label={this.props.intl.formatMessage({
                    id: "registerOrderRequest.approver",
                  })}
                >
                  <Input value={state.order?.approver?._instanceName} disabled={true} />
                </Form.Item>

                <Form.Item
                  style={styleInput.style}
                  label={this.props.intl.formatMessage({
                    id: "registerOrderRequest.responsible",
                  })}
                >
                  <Input value={state.order?.responsible?._instanceName} disabled={true} />
                </Form.Item>
              </div>

              {/*2 oo */}
              <div className="flex flex-col gap-4 lg:flex-row">
                <Form.Item
                  style={styleInput.style}
                  label={this.props.intl.formatMessage({
                    id: "orderChangeRequest.orderNumber",
                  })}
                >
                  <Input value={state.order?.orderNumber} disabled={true} />
                </Form.Item>

                <Form.Item
                  style={{ ...styleInput.style }}
                  label={this.props.intl.formatMessage({
                    id: "orderChangeRequest.orderDate",
                  })}
                >
                  <DefaultDatePicker style={{ width: "100%" }} value={moment(state.order?.orderDate || undefined)}
                                     disabled={true} />
                </Form.Item>

                <ReadonlyField
                  entityName={OrderChangeRequest.NAME}
                  propertyName="status"
                  disabled={true}
                  form={this.props.form}
                  formItemOpts={styleInput}
                  optionsContainer={this.statusesDc}
                />

              </div>

              {/*3 oo*/}
              {/*<div className="flex flex-col gap-4 lg:flex-row">*/}
              {/*  <ReadonlyField*/}
              {/*    entityName={OrderChangeRequest.NAME}*/}
              {/*    propertyName="requestNumber"*/}
              {/*    form={this.props.form}*/}
              {/*    formItemOpts={styleInput}*/}
              {/*    disabled={true}*/}
              {/*  />*/}


              {/*  <ReadonlyField*/}
              {/*    entityName={OrderChangeRequest.NAME}*/}
              {/*    propertyName="requestDate"*/}
              {/*    form={this.props.form}*/}
              {/*    style={{ width: "100%" }}*/}
              {/*    formItemOpts={{ style: { ...styleInput.style } }}*/}
              {/*    disabled={true}*/}
              {/*  />*/}

              {/*  <Form.Item*/}
              {/*    style={styleInput.style}*/}
              {/*    label={this.props.intl.formatMessage({*/}
              {/*      id: "registerOrderRequest.parentOrder",*/}
              {/*    })}*/}
              {/*  >*/}
              {/*    <Input value={state.order?.parentOrder?.orderNumber} disabled={true} />*/}
              {/*  </Form.Item>*/}
              {/*</div>*/}

              <Form.Item
                style={styleInput.style}
                label={this.props.intl.formatMessage({
                  id: "orderChangeRequest.orderDescription",
                })}
              >
                <Input.TextArea rows={3} value={state.order?.comment} disabled={true} />
              </Form.Item>

              {/*<CardCollapse title={<FormattedMessage id={"persons"} />}>*/}
              {/*  <TableAdaptive<PersonGroupExt>*/}
              {/*    scroll={{ x: 800 }}*/}
              {/*    isNeedMobile={true}*/}
              {/*    dataSource={state.order?.employees?.map((item) => item?.employee) || []}*/}
              {/*    columns={getTableRegisterOrderFields(this.props.intl, undefined, undefined)}*/}
              {/*  />*/}
              {/*</CardCollapse>*/}

              <CardCollapse title={<FormattedMessage id={"dismissal.workAroundSheet.attachments"} />}>
                <AttachmentsComponent
                  isForecast={false}
                  isNeedCreate={false}
                  isNeedDelete={false}
                  isNeedComment={false}
                  isNeedSelect={false}
                  columns={this.columnsAttachments}
                  items={(files as any) || []}
                  setAttachment={() => undefined}
                  keyComment={"fileComment"}
                />
              </CardCollapse>

              {this.takCard()}


              {(this.dataInstance.item && this.isNotDraftVRE()) &&
                <OrderRegisterSheet entityId={this.props.entityId || ""} orderId={this.dataInstance.item?.id} />
              }

              {this.globalErrors.length > 0 && (
                <Alert
                  message={<MultilineText lines={toJS(this.globalErrors)} />}
                  type="error"
                  style={{ marginBottom: "24px" }}
                />
              )}
            </Form>
          </Card>
        </PageWrapper>
      </Spin>
    );
  }

  updateAndCommit = () => {
    this.updateItemValue();

    // this.dataInstance.setItem({ order: this.state.order });

    return this.dataInstance.commit();
  };

  async getData() {
    this.setState({ isLoading: true });

    try {
      const { entityId, rootStore, form } = this.props;

      if (entityId === "new") return;

      const result = await getCubaREST()!.loadEntity<OrderRegisterFull>(
        OrderRegister.NAME,
        entityId,
        { view: "orderRegister.browse" },
      );

      this.dataInstance.setItem(result);

      const fieldValues = this.dataInstance.getFieldValues(this.fields);

      this.setState({
        order: result,
      });

      form.setFieldsValue({
        ...fieldValues,
      });

      this.loadBpmProcessData();
    } catch (error) {
      console.error("Ошибка при загрузке данных:", error);
    } finally {
      this.setState({ isLoading: false });
    }

  }

  componentDidMount() {
    super.componentDidMount();
    this.getData();
    const isMobilePath = this.props.location.pathname.includes("mobile");


    this.afterSendOnApprove = () => {
      if (isMobilePath) {
        this.props.history.push(`/${MOBILE_ROUTES.registerOrderRequest}/${this.props.entityId}`);
        return;
      }

      this.props.history.push("/");
      return;
    };
  }

  loadPersonProfile() {
    if (!this.state.personGroupId) return;
    restServices.employeeService.personProfile(this.state.personGroupId)
      .then(value => {
        this.person = value;
        if (this.props.form) {
          this.props.form.setFields({
            employeeName: { value: value.fullName },
            initiatorPersonGroup: { value: value.groupId },
          });
        }
      });
  }

  processInstanceBusinessKey = (): string => {
    if (!this.dataInstance.item?.registerOrderRequest?.id) return "";
    return this.dataInstance.item?.registerOrderRequest?.id;
  };

  componentDidUpdate(prevProps: any, prevState: State) {

    if (!this.state.personGroupId && this.props.entityId === "new") {
      this.setState({ personGroupId: this.props.rootStore!.userInfo.personGroupId });
    }

    if (this.state.isFirstLoading || this.state.personGroupId !== prevState.personGroupId) {

      this.setState({ isFirstLoading: false });
      void this.loadPersonProfile();

      if (this.props.entityId !== "new") {
        restServices.getNewAbbService.getSignFile(this.props.entityId || "", "DISMISSAL").then((res) => {
          this.setState((prevState: any) => ({
            documentInfo: {
              ...prevState.documentInfo,
              isSignatureRequired: res.isSignatureRequired,
              ucoSignRegistrationId: res.ucoSignRegistrationId,
            },
          }));
        });
      }
    }
  }


  initVariablesByBproc = () => {
    if (this.activeUserTask && this.activeUserTask.hrRole && this.activeUserTask.hrRole.code) {
      this.approverHrRoleCode = this.activeUserTask.hrRole.code;
    }
  };
}

export default injectIntl(
  withLocalizedForm<EditorProps>()(withRouter(RegisterOrderComponent)),
);
